<template>
  <div class="container-fluid mt-4" :class="themeClass">
    <div class="card shadow-sm">
      <div class="card-header fw-bold">
        Registrar nuevo cliente.
      </div>
      <div class="card-body">
        <form @submit.prevent="submitForm">
          <!-- Sección Identificación -->
          <div class="row mb-3">
            <div class="col-md-4">
              <label for="tipoId" class="form-label">Tipo de identificación <span class="text-danger">*</span></label>
              <select v-model="form.tipoId" id="tipoId" class="form-select" required>
                <option value="">Seleccione</option>
                <option v-for="tipo in tiposIdentificacion" :key="tipo.id" :value="tipo.codigo">
                  {{ tipo.tipo_de_identificacion }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label for="identificacion" class="form-label">Identificación <span class="text-danger">*</span></label>
              <input
                v-model="form.identificacion"
                type="text"
                id="identificacion"
                class="form-control"
                required
              />
            </div>
            <div class="col-md-4">
              <label for="razonSocial" class="form-label">Razón Social / Nombre <span class="text-danger">*</span></label>
              <input v-model="form.razonSocial" type="text" id="razonSocial" class="form-control" required />
            </div>
          </div>

          <!-- Sección Contacto y Dirección -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="correo" class="form-label">Correo electrónico</label>
              <input v-model="form.correo" type="email" id="correo" class="form-control" />
            </div>
            <div class="col-md-6">
              <label for="telefono" class="form-label">Teléfono</label>
              <input v-model="form.telefono" type="text" id="telefono" class="form-control" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="direccion" class="form-label">Dirección</label>
              <input v-model="form.direccion" type="text" id="direccion" class="form-control" />
            </div>
          </div>

          <div class="d-grid d-md-flex justify-content-md-end mt-4">
            <button type="submit" class="btn btn-primary">
              <i class="bi bi-save me-1"></i> Guardar cliente
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import themeManager from '@/store/theme'
import { clientService } from '@/services/clientService'
import api from '@/services/api'

export default {
  name: 'ClientBillingCreate',
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  data() {
    return {
      tiposIdentificacion: [],
      form: {
        tipoId: '',
        identificacion: '',
        razonSocial: '',
        telefono: '',
        correo: '',
        direccion: ''
      }
    }
  },
  async mounted() {
    this.fetchTiposIdentificacion()
  },
  methods: {
    async fetchTiposIdentificacion() {
      try {
        const res = await api.get('/tipos-identificacion-sri')
        this.tiposIdentificacion = res.data?.data || []
      } catch (e) {
        console.error('Error cargando tipos de identificación', e)
      }
    },
    async submitForm() {
      try {
        const payload = {
          tipo_identificacion: this.form.tipoId,
          identification_number: this.form.identificacion,
          business_name: this.form.razonSocial,
          email: this.form.correo,
          phone: this.form.telefono,
          address: this.form.direccion
        }
        await clientService.createClient(payload)
        alert('Cliente creado exitosamente')
        this.$router.push('/personas/clientes')
      } catch (error) {
        const msg = error.response?.data?.error || error.message
        alert('Error al crear cliente: ' + msg)
      }
    }
  }
}
</script>

<style scoped>
/* Estilos específicos para el formulario */
.card {
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0 !important;
  padding: 1.5rem;
  font-size: 1.1rem;
}

.card-body {
  padding: 2rem;
}

.form-label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.form-control,
.form-select {
  border-radius: 8px;
  padding: 0.75rem 1rem;
  border: 2px solid #e1e5e9;
  transition: all 0.3s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
</style>


